import { TABS, DEFAULT_TAB } from '../../shared/tabs.js';

// Persistencia del pedido en localStorage. Versionada: si en el
// futuro cambia la forma del estado, se incrementa la versión y
// los pedidos viejos se descartan en lugar de romper la app.
const STORAGE_KEY = 'order:v1';

export const loadStoredOrder = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const cantidadesPorTab = Object.fromEntries(
      TABS.map(t => {
        const fromStore = parsed.cantidadesPorTab && parsed.cantidadesPorTab[t.id];
        return [t.id, fromStore && typeof fromStore === 'object' ? fromStore : {}];
      })
    );
    return {
      cantidadesPorTab,
      nombre: typeof parsed.nombre === 'string' ? parsed.nombre : '',
      empresa: typeof parsed.empresa === 'string' ? parsed.empresa : '',
      activeTab: TABS.some(t => t.id === parsed.activeTab) ? parsed.activeTab : DEFAULT_TAB
    };
  } catch (_) {
    return null;
  }
};

export const saveStoredOrder = (snapshot) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
  } catch (_) { /* cuota excedida o storage deshabilitado */ }
};

export const clearStoredOrder = () => {
  try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
};
